<template>
  <div v-if="permissionCheck('Shift_Plans','Read')" class="container-fluid">
    <div class="row actions">
      <div class="col-md-3 float-left">
        Home > Shift Plans
      </div>
      <div class="col-md-9">
        <button v-if="permissionCheck('Shift_Plans','Create')" class="btn btn-success float-right" style="margin-right: 5px;" @click="createShiftPlan">Create Shift Plan</button>
        <button v-if="adminCheck" class="btn btn-warning float-right" style="margin-right: 5px;" @click="makeAttendance">Rebuild Attendace Data</button>
      </div>
    </div>

    <div v-show="processLoader" class="container">
      <div class="row shadows" style="padding: 50px; background-color: white; margin: 20px;">
        <div class="col">
          <div align="center"><semipolar-spinner :animation-duration="2500" :size="200" :color="'#62a622'" ></semipolar-spinner></div>
          <h3 align="center">Please wait... Attendance Timesheet Data is Rebuilt</h3>
          <h5 align="center">This process might take few minutes</h5>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col content">
        <h1 v-if="!newShift" align="center"><icon name="refresh" scale="3"></icon> <br/> SHIFTS PLANS</h1>
        <h1 v-if="newShift" align="center"><icon name="refresh" scale="3"></icon></h1>

        <!------------------------------------------------->
        <!--------------- Shifts Listing Table------------->
        <!------------------------------------------------->

        <div v-if="shifts.length > 0 && !selectedShift && !newShift" class="container-fluid shadows" style="width:90%; margin-top: 30px;">
          <div class="row">

            <!--Tickets List Table-->
            <table class="table table-hover">
              <thead>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">ID</th>
              <th scope="col" style="font-size: 12px; min-width: 175px; background-color: #fffaf0;">Plan Name</th>
              <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">Start Date</th>
              <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">End Date</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Shift Name</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Total Users</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Priority</th>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;"></th>
              </thead>

              <tbody>

              <tr v-for="shiftPlan in shiftPlans" v-if="findShift(shiftPlan.shifts_id)">
                <td style="font-size: 12px; cursor: pointer;" @click="selectShift(shiftPlan)">{{shiftPlan.id}}</td>
                <td style="font-size: 12px; cursor: pointer;" @click="selectShift(shiftPlan)">{{shiftPlan.name}}</td>
                <td style="font-size: 12px; cursor: pointer;" @click="selectShift(shiftPlan)">{{$moment(shiftPlan.startDate).format('ddd DD-MM-YYYY')}}</td>
                <td style="font-size: 12px; cursor: pointer;" @click="selectShift(shiftPlan)">{{$moment(shiftPlan.endDate).format('ddd DD-MM-YYYY')}}</td>
                <td style="font-size: 12px; cursor: pointer;" @click="selectShift(shiftPlan)">
                <span v-if="findShift(shiftPlan.shifts_id)" class='badge badge-success' style="font-size: 12px;">
                  <router-link style="color: white;" :to="'/hr/shifts'+'#'+shiftPlan.shifts_id">{{findShift(shiftPlan.shifts_id).name}}</router-link>
                </span>
                </td>
                <td style="font-size: 12px; cursor: pointer;" @click="selectShift(shiftPlan)">{{shiftPlan.usersCount}} Users</td>
                <td style="font-size: 12px; cursor: pointer;" @click="selectShift(shiftPlan)">{{shiftPlan.sortOrder}}</td>
                <td style="font-size: 12px; cursor: pointer;">
                  <button v-if="permissionCheck('Shift_Plans','Update')" class="btn btn-sm btn-primary float-right" type="submit" style="margin-right: 5px;" @click="selectShift(shiftPlan)"><icon name="calendar"></icon> Update</button>
                  <button v-if="permissionCheck('Shift_Plans','Delete')" class="btn btn-sm btn-danger float-right" type="button" style="margin-right: 5px;" @click="deleteShift(shiftPlan)"><icon name="times"></icon></button>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>



        <!------------------------------------------------->
        <!-------------- Shifts Details Section ----------->
        <!------------------------------------------------->

        <div v-if="selectedShift">
          <form @submit.prevent="onShiftSave">

            <div  class="container shadows" style="margin-top: 30px; margin-bottom: 30px;">
              <div class="row" style="background-color: #f8f8f8; border-bottom: 1px solid #bababa;  padding-top: 22px;">
                <div class="col-md-12" style="padding: 20px;">
                  <h4 align="center"><icon name="calendar" scale="3"></icon> &nbsp;  &nbsp; {{shiftUpdateForm.name}}</h4>
                </div>
              </div>


              <div class="row" style="padding: 15px;">
                <div class="col-md-2">
                  <strong>Name:</strong>
                </div>
                <div class="col-md-4">
                  <input class="form-control" v-model="shiftUpdateForm.name" type="text" required/>
                </div>
                <div class="col-md-2">
                  <strong>Shift:</strong>
                </div>
                <div class="col-md-4">
                  <div class="float-left" style="width:90%;">
                    <select v-model="shiftUpdateForm.shifts_id" name="period" class="form-control" required>
                      <option v-for="shift in shifts" :value="shift.id">{{shift.name}}</option>
                    </select>
                  </div>
                  <div class="float-right" style="padding-top: 7px;"><router-link :to="'/hr/shifts'+'#'+shiftUpdateForm.shifts_id">
                    <icon name="sign-out" scale="1.5"></icon></router-link>
                  </div>
                </div>
              </div>

              <div class="row" style="padding: 15px;">
                <div class="col-md-2">
                  <strong>Date From:</strong>
                </div>
                <div class="col-md-4">
                  <date-picker
                      v-model="dateSelect.dateFrom1"
                      type="date"
                      @change="setDateFrom"
                      :placeholder = "shiftUpdateForm.startDate"
                      format="dd-MM-yyyy"
                      :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                      lang="en">
                  </date-picker>
                </div>
                <div class="col-md-2">
                  <strong>Date To:</strong>
                </div>
                <div class="col-md-4">
                  <date-picker
                      v-model="dateSelect.dateTo1"
                      type="date"
                      @change="setDateTo"
                      :placeholder = "shiftUpdateForm.endDate"
                      format="dd-MM-yyyy"
                      :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                      lang="en">
                  </date-picker>
                </div>
              </div>

              <div class="row" style="padding: 15px;">
                <div class="col-md-2">
                  <strong>Priority:</strong>
                </div>
                <div class="col-md-4">
                  <select v-model="shiftUpdateForm.sortOrder" name="period" class="form-control" required>
                    <option v-for="priority in priorities" :value="priority.id">{{priority.name}}</option>
                  </select>
                </div>
              </div>

              <div class="row" style="padding: 15px;">
                <div class="col-md-12">
                  <button v-if="permissionCheck('Shift_Plans','Update')" class="btn btn-success float-right" type="submit" style="margin-right: 5px;"><icon name="save"></icon> Update Shift Plan</button>
                  <button v-if="adminCheck" class="btn btn-warning float-right" @click="reprocessAttendance" type="button" style="margin-right: 5px;"><icon name="refresh"></icon> Reprocess Attendance</button>
                  <button class="btn btn-danger float-right" @click="cancelNewShift" type="button" style="margin-right: 5px;"><icon name="times"></icon> Close</button>
                </div>


                <div v-show="processLoader" class="container">
                  <div class="row shadows" style="padding: 50px; background-color: white; margin: 20px;">
                    <div class="col">
                      <div align="center"><semipolar-spinner :animation-duration="2500" :size="200" :color="'#62a622'" ></semipolar-spinner></div>
                      <h3 align="center">Please wait... Attendance Timesheet Data is Rebuilt</h3>
                      <h5 align="center">This process might take few minutes</h5>
                    </div>
                  </div>
                </div>


              </div>
            </div>

          </form>


          <!------------------------------------------------->
          <!---- Filtered Criteria For Searched Users ------->
          <!------------------------------------------------->
          <div  class="container shadows" style="margin-top: 30px; margin-bottom: 30px;">
            <div class="row" style="background-color: #f8f8f8; border-bottom: 1px solid #bababa;  padding-top: 22px;">
              <div class="col-md-6" style="padding: 20px;">
                <h4><icon name="calendar" scale="2"></icon> &nbsp;  &nbsp; Manage Shift Plan Employees</h4>
              </div>
              <div class="col-md-6">
                <button v-if="selectedShift" class="btn btn-primary float-right" @click="$refs.searchFilter.show()" type="button"><icon name="search"></icon> Search Users</button>
              </div>
            </div>

            <div class="row" style="padding: 15px;">
              <div class="row" style="background-color: rgba(0,0,0,0.03); padding: 5px;" v-if="searchFilters.isActive">
                <div class="col-md-12" style="background-color: rgba(0,0,0,0.06); text-align: center; font-size: 18px; padding: 10px; border: 1px solid rgba(0,0,0,0.2);">
                  SEARCH CRITERIA
                </div>

                <div class="col-md-6" v-if="searchFilters.companies.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Cost Company</strong></div>
                    <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.companies"><b-badge variant="info">{{findCompany(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.sponsorCompanies.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Sponsor Company</strong></div>
                    <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.sponsorCompanies"><b-badge variant="info">{{findSponsorCompany(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.branches.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Branches</strong></div>
                    <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.branches"><b-badge variant="info">{{findBranch(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.departments.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Departments</strong></div>
                    <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.departments"><b-badge variant="info">{{findDepartment(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.designations.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Designations</strong></div>
                    <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.designations"><b-badge variant="info">{{findDesignation(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.religions.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Religions</strong></div>
                    <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.religions"><b-badge variant="info">{{findReligion(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.nationalities.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Nationalities</strong></div>
                    <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.nationalities"><b-badge variant="info">{{findNationality(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.cities.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Cities</strong></div>
                    <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.cities"><b-badge variant="info">{{data}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="searchFilters.employees.length > 0">
                  <div class="row">
                    <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Employees</strong></div>
                    <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                      <span v-for="data in searchFilters.employees"><b-badge variant="info">{{findUser(data).name}}</b-badge>&nbsp;</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" style="padding: 10px;">
                  <button style="float: right;" class="btn btn-secondary" @click="$refs.searchFilter.show()" type="button"><icon name="search"></icon> Modify Filter</button>
                  <button class="btn btn-success float-right" type="button" style="margin-right: 5px;" @click="searchFilterRecords('shift')"><icon name="users"></icon> Search Users</button>
                </div>
              </div>
              <div v-if="timesheetsList.length == 0">
                <p align="center">Currently there are no results for the requested search criteria</p>
                <p align="center">Please use the search filter to find the records. </p>
              </div>
            </div>

            <div class="row" style="padding: 15px;">
              <!--Tickets List Table-->
              <table class="table table-hover" style="margin-top: 10px;" v-if="timesheetsList.length > 0">
                <thead>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;"><span @click="sortToggle('id')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('id')"></icon></span> ID</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;"><span @click="sortToggle('name')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('name')"></icon></span> Name</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;"><span @click="sortToggle('company')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('company')"></icon></span> Cost Company</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;"><span @click="sortToggle('sponsorCompany')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('sponsorCompany')"></icon></span> Sponsor Company</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Branch</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Department</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Designation</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Nationality</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Religion</th>
                <th scope="col" style="font-size: 12px; background-color: #fffaf0;"><span @click="sortToggle('shift')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('shift')"></icon></span> Status</th>
                </thead>

                <tbody>
                <tr v-for="employee in timesheetsList">
                  <td style="font-size: 12px; cursor: pointer;">{{employee.id}}</td>
                  <td style="font-size: 12px; cursor: pointer;" @click="selectEmployee(employee)">{{employee.name}}</td>
                  <td style="font-size: 12px; cursor: pointer;">{{employee.company}}</td>
                  <td style="font-size: 12px; cursor: pointer;">{{employee.sponsorCompany}}</td>
                  <td style="font-size: 12px; cursor: pointer;">
                                    <span v-if="employee.branches">
                                        <span v-if="employee.branches.length > 0" v-for="branchID in employee.branches">
                                            <span v-if="findBranch(branchID)">{{findBranch(branchID).name}} &nbsp;</span>
                                        </span>
                                    </span>
                  </td>
                  <td style="font-size: 12px; cursor: pointer;">
                                    <span v-if="employee.departments">
                                        <span v-if="employee.departments.length > 0" v-for="departmentID in employee.departments">
                                            <span v-if="findDepartment(departmentID)">{{findDepartment(departmentID).name}} &nbsp;</span>
                                        </span>
                                    </span>
                  </td>
                  <td style="font-size: 12px; cursor: pointer;">{{employee.designation}}</td>
                  <td style="font-size: 12px; cursor: pointer;">{{employee.nationality}}</td>
                  <td style="font-size: 12px; cursor: pointer;">{{employee.religion}}</td>
                  <td style="font-size: 12px; cursor: pointer;">

                    <toggle-button :value="onSelectShiftPlanSpecific(selectedShift.id, employee.shiftPlans)"
                                   v-if="permissionCheck('Shift_Plans','Update')"
                                   color="#82C7EB"
                                   @change="toggleAssociation(selectedShift.id, employee.id)"
                                   :sync="true"
                                   :labels="{checked: 'Yes', unchecked: 'No'}">
                    </toggle-button>
                  </td>
                </tr>
                </tbody>
              </table>
              <!--Pagination Links-->
              <div class="col-md-12 standout" v-if="timesheetsList.length > 0" v-show="!timesheetsListLoading"  >
                <div class="row">
                  <div class="col text-left" style="padding-top: 8px; font-size: 12px;">Total: {{timesheetsPaginationObject.totalRecords}} Employees</div>
                  <div class="col text-center" style="min-width: 200px; font-size: 12px;">
                    <button @click="updateRecordsList(1)" :disabled="!timesheetsPaginationObject.firstActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"><icon name="angle-double-left"></icon></button>
                    <button @click="updateRecordsList(timesheetsPaginationObject.currentPage-1)" :disabled="!timesheetsPaginationObject.previousActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-left"></icon> </button>
                    &nbsp; {{timesheetsPaginationObject.currentPage}} of {{timesheetsPaginationObject.totalPages}} &nbsp;
                    <button @click="updateRecordsList(timesheetsPaginationObject.currentPage+1)" :disabled="!timesheetsPaginationObject.nextActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-right"></icon> </button>
                    <button @click="updateRecordsList(timesheetsPaginationObject.totalPages)" :disabled="!timesheetsPaginationObject.lastActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-double-right"></icon> </button>
                  </div>
                  <div class="col text-right" style="float:right;">
                    <select v-model="sorting.limit" class="form-control" style="max-width: 140px; float: right;">
                      <option :value="100">100 Per Page</option>
                      <option :value="200">200 Per Page</option>
                      <option :value="300">300 Per Page</option>
                      <option :value="400">400 Per Page</option>
                      <option :value="500">400 Per Page</option>
                      <option :value="10000">All Records</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>

        <!------------------------------------------------->
        <!-------------- Create New Shift Form ------------>
        <!------------------------------------------------->

        <form @submit.prevent="onShiftSave">
          <div v-if="newShift">
            <h1 align="center">Create a New Shift Plan<br/> &nbsp;</h1>

            <div class="container shadows" style="margin-top: 30px;">
              <div class="row" style="margin: 30px;">
                <div class="col-md-1" style="padding-top: 5px;">
                  <strong>Name:</strong>
                </div>
                <div class="col-md-3">
                  <input class="form-control" v-model="shiftCreateForm.name" type="text" required/>
                </div>
                <div class="col-md-1" style="padding-top: 5px;">
                  <strong class="">Shift:</strong>
                </div>
                <div class="col-md-4">
                  <select v-model="shiftCreateForm.shiftID" name="period" class="form-control" required>
                    <option v-for="shift in shifts" :value="shift.id">{{shift.name}}</option>
                  </select>
                </div>
                <div class="col-md-1" style="padding-top: 5px;">
                  <strong class="">Priority:</strong>
                </div>
                <div class="col-md-2">
                  <select v-model="shiftCreateForm.sortOrder" name="period" class="form-control" required>
                    <option v-for="priority in priorities" :value="priority.id">{{priority.name}}</option>
                  </select>
                </div>

              </div>

              <div class="row" style="margin: 30px;">
                <div class="col-md-1" style="padding-top: 5px;">
                  <strong class="">From:</strong>
                </div>
                <div class="col-md-3">
                  <date-picker
                      v-model="dateSelect.dateFrom1"
                      type="date"
                      @change="setDateFromCreate"
                      :placeholder = "shiftCreateForm.startDate"
                      format="dd-MM-yyyy"
                      :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                      lang="en">
                  </date-picker>
                </div>
                <div class="col-md-1" style="padding-top: 5px;">
                  <strong class="">To:</strong>
                </div>
                <div class="col-md-3">
                  <date-picker
                      v-model="dateSelect.dateTo1"
                      type="date"
                      @change="setDateToCreate"
                      :placeholder = "shiftCreateForm.endDate"
                      format="dd-MM-yyyy"
                      :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                      lang="en">
                  </date-picker>
                </div>
                <div class="col-md-4" style="padding-top: 7px;">
                  <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;"><icon name="save"></icon> Save Plan</button>
                  <button v-if="newShift" class="btn btn-danger float-right" @click="cancelNewShift" type="button" style="margin-right: 5px;"><icon name="save"></icon> Cancel</button>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Search Filter Modal -->
    <form @submit.prevent="onSearchFilters">
      <b-modal ref="searchFilter" size="lg" centered >
        <div slot="modal-header">
          <h3>Time and Attendance: Search Filter</h3>
        </div>

        <b-container fluid>

          <div class="form-group row">
            <div class="col">
              <small class="form-text text-muted"> <icon name="building"></icon> <strong>Cost Company</strong></small>
              <multiselect
                  v-model="searchFilters.companies2"
                  :options="companies"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectCostCompany"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>

            <div class="col">
              <small class="form-text text-muted"> <icon name="building"></icon> <strong>Sponsor Company</strong></small>
              <multiselect
                  v-model="searchFilters.sponsorCompanies2"
                  :options="sponsorCompanies"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectSponsorCompany"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>
          </div>

          <div class="form-group row">
            <div class="col">
              <small class="form-text text-muted"> <icon name="building"></icon> <strong>Branch</strong></small>
              <multiselect
                  v-model="searchFilters.branches2"
                  :options="branches"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectBranches"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>

            <div class="col">
              <small class="form-text text-muted"> <icon name="list"></icon> <strong>Departments</strong></small>
              <multiselect
                  v-model="searchFilters.departments2"
                  :options="departments"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectDepartments"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>
          </div>

          <div class="form-group row">
            <div class="col">
              <small class="form-text text-muted"> <icon name="map-pin"></icon> <strong>City</strong></small>
              <multiselect
                  v-model="searchFilters.cities2"
                  :options="cities"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectCities"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>

            <div class="col">
              <small class="form-text text-muted"> <icon name="globe"></icon> <strong>Nationality</strong></small>
              <multiselect
                  v-model="searchFilters.nationalities2"
                  :options="nationalities"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectNationalities"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>
          </div>

          <div class="form-group row">
            <div class="col">
              <small class="form-text text-muted"> <icon name="briefcase"></icon> <strong>Designation</strong></small>
              <multiselect
                  v-model="searchFilters.designations2"
                  :options="designations"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectDesignations"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>

            <div class="col">
              <small class="form-text text-muted"> <icon name="book"></icon> <strong>Religion</strong></small>
              <multiselect
                  v-model="searchFilters.religions2"
                  :options="religions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectReligions"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>
          </div>

          <div class="form-group row">

            <div class="col">
              <small class="form-text text-muted"> <icon name="users"></icon> <strong>Employee By ID</strong></small>
              <multiselect
                  v-model="searchFilters.employees2"
                  :options="users"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectUsers"
                  label="id"
                  track-by="id"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.id }} - {{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.id }} - {{ props.option.name }}
                </template>
              </multiselect>
            </div>

            <div class="col">
              <small class="form-text text-muted"> <icon name="users"></icon> <strong>Employee By Name</strong></small>
              <multiselect
                  v-model="searchFilters.employees2"
                  :options="users"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectUsers"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.id }} - {{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.id }} - {{ props.option.name }}
                </template>
              </multiselect>
            </div>

            <div class="col">
              <small class="form-text text-muted"> <icon name="building"></icon> <strong>Status</strong></small>
              <multiselect
                  v-model="searchFilters.status2"
                  :options="statuses"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :hide-selected="true"
                  :preserve-search="true"
                  placeholder=""
                  @input="onSelectStatus"
                  label="name"
                  track-by="name"
                  :preselect-first="false">
                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                </template>
                <template slot="option" slot-scope="props">
                  {{ props.option.name }}
                </template>
              </multiselect>
            </div>

          </div>
        </b-container>

        <div slot="modal-footer">
          <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('shift')"><icon name="users"></icon> Search Users</button>
          <button class="btn btn-dark float-right" type="reset" style="margin-right: 5px;" @click="searchFilterClear('open')"><icon name="minus-square"></icon> Clear Filters</button>
          <button class="btn btn-danger float-right" type="button" style="margin-right: 5px;" @click="$refs.searchFilter.hide()"><icon name="times"></icon> Cancel</button>
        </div>
      </b-modal>
    </form>

  </div>
</template>

<script>
    import axios from 'axios'
    import router from './../../../router'
    import {Form, Errors} from '@/components/validations/forms';
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        name: 'AlertsZone',
        data () {
            return {
                shifts: this.$store.getters['shifts/getShifts'],
                shiftPlans: this.$store.getters['shifts/getShiftPlans2'],
                users: this.$store.getters['user/getUsers'],
                selectedShift: null,
                newShift: false,
                processLoader: false,

                // User Filter
                timesheetsList: [],
                timesheetsPages: null,
                timesheetsPaginationObject: {
                    totalRecords : 0,
                    totalPages : 0,
                    currentPage : 0,
                    first : 0,
                    firstActive : false,
                    previous : 0,
                    previousActive : false,
                    next : 0,
                    nextActive : false,
                    last : 0,
                    lastActive : false,
                },
                searchFilters: this.$store.getters['shifts/getSearchFilters'],
                sorting: this.$store.getters['shifts/getSorting'],
                dropdownx: this.$route.hash.substring(1),
                resultsView: "shift",

                companies: this.$store.getters['environment/getCompanies'],
                sponsorCompanies: this.$store.getters['environment/getSponsorCompanies'],
                divisions: this.$store.getters['environment/getDivisions'],
                branches: this.$store.getters['environment/getBranches'],
                departments: this.$store.getters['environment/getDepartments'],
                designations: this.$store.getters['environment/getDesignations'],
                religions: this.$store.getters['environment/getReligions'],
                nationalities: this.$store.getters['environment/getNationalities'],
                groups: this.$store.getters['environment/getGroups'],
                cities: this.$store.getters['environment/getCities'],

                shiftCreateForm: new Form({
                    name: null,
                    startDate: null,
                    endDate: null,
                    shiftID: null,
                    sortOrder: 1,
                }),

                shiftUpdateForm: new Form({
                    id: null,
                    name: null,
                    startDate: null,
                    endDate: null,
                    shiftID: null,
                    sortOrder: 1,
                }),

                timePickerOptions: [
                    '00:00:00','00:30:00','01:00:00','01:30:00','02:00:00','02:30:00','03:00:00','03:30:00','04:00:00','04:30:00','05:00:00','05:30:00','06:00:00','06:30:00','07:00:00','07:30:00','08:00:00','08:30:00',
                    '09:00:00','09:30:00','10:00:00','10:30:00','11:00:00','11:30:00','12:00:00','12:30:00','13:00:00','13:30:00','14:00:00','14:30:00','15:00:00','15:30:00','16:00:00','16:30:00','17:00:00','17:30:00',
                    '18:00:00','18:30:00','19:00:00','19:30:00','20:00:00','20:30:00','21:00:00','21:30:00','22:00:00','22:30:00','23:00:00','23:30:00'
                ],

                priorities: [
                    {id: 1, name: '1 - Standard'},
                    {id: 2, name: '2 - High'},
                    {id: 3, name: '3 - Ramadan'},
                    {id: 4, name: '4 - Top'},
                ],
            }
        },

        methods: {
            selectShift(shiftplan){
                let shift = shiftplan;
                if(!shift.name){
                    this.$store.dispatch('shifts/fetchShiftPlan', shift)
                        .then(response => {
                            shift = response.data;
                            this.selectedShift = shift;
                            this.shiftUpdateForm.id = shift.id;
                            this.shiftUpdateForm.sortOrder = shift.sortOrder;
                            this.shiftUpdateForm.shifts_id = shift.shifts_id;
                            this.shiftUpdateForm.name = shift.name;
                            this.shiftUpdateForm.startDate = shift.startDate;
                            this.shiftUpdateForm.endDate = shift.endDate;
                            this.searchFilters.shiftPlans = shift.id;
                            this.updateRecordsList();
                        })
                        .catch(error => {
                            this.$snotify.error(error.message);
                        })
                } else{
                    this.selectedShift = shift;
                    this.shiftUpdateForm.id = shift.id;
                    this.shiftUpdateForm.sortOrder = shift.sortOrder;
                    this.shiftUpdateForm.shifts_id = shift.shifts_id;
                    this.shiftUpdateForm.name = shift.name;
                    this.shiftUpdateForm.startDate = shift.startDate;
                    this.shiftUpdateForm.endDate = shift.endDate;
                    this.searchFilters.shiftPlans = shift.id;
                    this.updateRecordsList();
                }
            },
            closeShift(){
                this.selectedShift = null;
                this.resetShiftUpdateForm();
                this.$store.dispatch('shifts/resetSearchFilters');
                this.searchFilters = this.$store.getters['shifts/getSearchFilters'];
            },
            resetShiftUpdateForm(){
                this.shiftUpdateForm.id = null;
                this.shiftUpdateForm.name = null;
            },

            // Shift Plan CRUD / Form Functions
            deleteShift(shift){
                if(confirm("Do you really want to delete?")) {

                    this.$store.dispatch('shifts/deleteShiftPlans', shift)
                        .then(response => {
                            this.loadShifts();
                            this.$snotify.success('Shift Plan Deleted');
                        })
                        .catch(error => {
                            this.shiftUpdateForm.onFail(error);
                            this.$snotify.error(this.shiftUpdateForm.errors.error.message, this.shiftUpdateForm.errors.error.title);
                        })
                }
            },
            onShiftSave(){
                if(this.selectedShift){
                    if(this.shiftUpdateForm.startDate && this.shiftUpdateForm.endDate && this.shiftUpdateForm.startDate < this.shiftUpdateForm.endDate){
                        this.updateShift();
                    } else{this.$snotify.error("Please select the correct Start Date and End Date");}

                } else{
                    if(this.shiftCreateForm.startDate && this.shiftCreateForm.endDate && this.shiftCreateForm.startDate < this.shiftCreateForm.endDate){
                        this.saveShift();
                    } else{this.$snotify.error("Please select the correct Start Date and End Date");}
                }
            },
            updateShift(){
                this.$store.dispatch('shifts/updateShiftPlans', this.shiftUpdateForm)
                    .then(response => {
                        this.loadShifts();
                        this.$snotify.success('Shift Plan Updated');
                    })
                    .catch(error => {
                        this.shiftUpdateForm.onFail(error);
                        this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
                    })

            },
            createShiftPlan(){
                this.newShift = true;
                this.selectedShift = null;
            },
            saveShift(){

                this.$store.dispatch('shifts/storeShiftPlans', this.shiftCreateForm)
                    .then(response => {
                        this.loadShifts();
                        this.newShift = false;
                        this.$snotify.success('Shift Plan Saved');
                        this.$store.dispatch('shifts/resetSearchFilters');
                        this.searchFilters = this.$store.getters['shifts/getSearchFilters'];
                    })
                    .catch(error => {
                        this.shiftUpdateForm.onFail(error);
                        this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
                    })
            },

            // Reprocess Attendances Etc.
            reprocessAttendance() {
                this.processLoader = true;
                this.$store.dispatch('shifts/reprocessAttendance', this.selectedShift.id)
                    .then(response => {
                        this.processLoader = false;
                        this.loadShifts();
                        this.$snotify.success('Shift Plan Attendance Reprocessed');
                    })
                    .catch(error => {
                        this.$snotify.error(error);
                    })
            },
            makeAttendance() {
                this.processLoader = true;
                this.$store.dispatch('shifts/makeAttendance')
                    .then(response => {
                        this.processLoader = false;
                        this.loadShifts();
                        this.$snotify.success('Shift Plan Attendance Reprocessed');
                    })
                    .catch(error => {
                        this.$snotify.error(error);
                        this.processLoader = false;
                    })
            },

            // Misc.
            cancelNewShift(){
                this.newShift = false;
                this.selectedShift = null;
                this.$store.dispatch('shifts/resetSearchFilters');
                this.searchFilters = this.$store.getters['shifts/getSearchFilters'];

            },
            setDateFrom(){
                if(this.dateSelect.dateFrom1){
                    this.shiftUpdateForm.startDate = this.$moment(this.dateSelect.dateFrom1).format('YYYY-MM-DD');
                } else{this.shiftUpdateForm.startDate = this.$moment().format('YYYY-MM-DD')}
            },
            setDateTo(){
                if(this.dateSelect.dateTo1){
                    this.shiftUpdateForm.endDate = this.$moment(this.dateSelect.dateTo1).format('YYYY-MM-DD');
                } else{this.shiftUpdateForm.endDate = this.$moment().format('YYYY-MM-DD')}
            },
            setDateFromCreate(){
                if(this.dateSelect.dateFrom1){
                    this.shiftCreateForm.startDate = this.$moment(this.dateSelect.dateFrom1).format('YYYY-MM-DD');
                } else{this.shiftCreateForm.startDate = this.$moment().format('YYYY-MM-DD')}
            },
            setDateToCreate(){
                if(this.dateSelect.dateTo1){
                    this.shiftCreateForm.endDate = this.$moment(this.dateSelect.dateTo1).format('YYYY-MM-DD');
                } else{this.shiftCreateForm.endDate = this.$moment().format('YYYY-MM-DD')}
            },
            findShift(id){for (let s of this.shifts) {if(s.id == id){return s}}},



            ////////////////////////////////////////////////////
            // Search Filter Form
            ////////////////////////////////////////////////////
            // Multi List Dropdown Cleanup Functions Based
            ////////////////////////////////////////////////////
            // These methods clean up objects of selected options and make an array of IDs in search filter form
            onSelectCostCompany(value){this.searchFilters.companies = value.map(a => a.id);},
            onSelectSponsorCompany(value){this.searchFilters.sponsorCompanies = value.map(a => a.id);},
            onSelectBranches(value){this.searchFilters.branches = value.map(a => a.id);},
            onSelectDepartments(value){this.searchFilters.departments = value.map(a => a.id);},
            onSelectCities(value){this.searchFilters.cities = value.map(a => a.name);},
            onSelectNationalities(value){this.searchFilters.nationalities = value.map(a => a.id);},
            onSelectDesignations(value){this.searchFilters.designations = value.map(a => a.id);},
            onSelectReligions(value){this.searchFilters.religions = value.map(a => a.id);},
            onSelectShiftPlans(value){this.searchFilters.shiftPlans = value.map(a => a.id);},
            onSelectShiftPlanSpecific(value, array){if(array.indexOf(value) > -1){return true;} else{return false;}},
            onSelectUsers(value){this.searchFilters.employees = value.map(a => a.id);},
            onSelectStatus(value){this.searchFilters.status = value.map(a => a.id);},
            onSearchFilters(){
                //
            },
            // Sorting Columns
            sortToggle(columnID){
                if(this.sorting.sortBy === columnID){
                    if(this.sorting.sortOrder === 'desc'){this.sorting.sortOrder = 'asc';}
                    else if(this.sorting.sortOrder === 'asc'){this.sorting.sortOrder = 'desc';}
                } else{
                    this.sorting.sortBy = columnID;
                    this.sorting.sortOrder = 'asc';
                }
                this.updateRecordsList();
            },
            sortToggleIcon(columnID){
                let icon = 'sort';
                if(this.sorting.sortBy === columnID){
                    if(this.sorting.sortOrder === 'asc'){icon = 'sort-up';}
                    if(this.sorting.sortOrder === 'desc'){icon = 'sort-down';}
                }
                return icon;
            },

            // This method clears the search filter popup and fetches in new records based on criteria
            searchFilterRecords(view){
                this.searchFilters.shiftPlans = this.selectedShift.id;
                this.searchFilters.resultsView = view;
                this.searchFilters.isActive = true;
                this.$refs.searchFilter.hide();
                this.updateRecordsList();
            },
            // This method clears the search filter results and selected criteria load default open tickets page
            searchFilterClear(redirect){
                this.searchFilters = JSON.parse(JSON.stringify(this.$store.getters['shifts/getDefaultSearchFilters']));
                this.$store.dispatch('shifts/resetSearchFilters');
                this.dateSelect = {};
                this.searchFilters.isActive = false;
                this.timesheetsList = [];
                this.$refs.searchFilter.hide()
            },
            // Update Tickets Pagination Object
            updateTicketsPaginationObject(){
                let paginationObject = null;

                let totalRecords = 0;
                let totalPages = 1;
                let currentPage = 1;
                let first = 1;
                let firstActive = false;
                let previous = 1;
                let previousActive = false;
                let next = 1;
                let nextActive = false;
                let last = 1;
                let lastActive = false;

                if(this.timesheetsPages['meta']){paginationObject = this.timesheetsPages['meta'];}
                if(paginationObject){
                    totalRecords = paginationObject.total;
                    totalPages = paginationObject.last_page;
                    currentPage = paginationObject.current_page;
                    first = 1;
                    if(currentPage > 1){previous = currentPage - 1;} else{previous = 1}
                    if(currentPage < totalPages){next = currentPage + 1;} else{next = totalPages}
                    last = paginationObject.last_page;

                    if(totalPages === 1){firstActive = false; previousActive = false; nextActive = false; lastActive = false;}
                    else{
                        if(currentPage > previous){firstActive = true; previousActive = true;}
                        if(currentPage < next){nextActive = true; lastActive = true;}
                        if(currentPage < next && currentPage > previous){firstActive = true; previousActive = true; nextActive = true; lastActive = true;}
                        if(currentPage === first){firstActive = false; previousActive = false; nextActive = true; lastActive = true;}
                        if(currentPage === last){firstActive = true; previousActive = true; nextActive = false; lastActive = false;}

                    }
                }

                this.timesheetsPaginationObject = {
                    totalRecords: totalRecords,
                    totalPages: totalPages,
                    currentPage: currentPage,
                    first: first,
                    firstActive: firstActive,
                    previous: previous,
                    previousActive: previousActive,
                    next: next,
                    nextActive: nextActive,
                    last: last,
                    lastActive: lastActive,
                };
            },
            // This method will be triggered whenever tickets list array needs to fetch in fresh tickets from the server
            updateRecordsList(page){
                this.timesheetsListLoading = true;
                if(!page){page = 1;}
                this.sorting.page = page;
                this.$store.dispatch('shifts/fetchTimesheetUsers', {filters: this.searchFilters, sorting: this.sorting})
                    .then(response => {
                        this.timesheetsList = this.$store.getters['shifts/getTimesheetUsers'];
                        this.timesheetsPages = this.$store.getters['shifts/getTimesheetPages'];
                        this.timesheetsListLoading = false;
                        this.updateTicketsPaginationObject();
                    })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    })
            },
            toggleAssociation(shiftPlanID, userID) {
                this.$store.dispatch('shifts/assignShiftPlan', {
                    userID: userID,
                    shiftPlanID: shiftPlanID,
                })
                    .then(response => {this.selectedShift = response.data;})
            },

            filterShiftPlans(){
                // let visibleStart = this.findVisibilityEnd().value;
                // let visibleEnd = this.findVisibilityStart().value;
                // this.shiftPlans = this.$store.getters['shifts/getShiftPlans'].filter(function (el) {
                //     return el.startDate <= visibleEnd && el.endDate >= visibleStart;
                // });
            },

            loadShifts(){
                // Load Shifts
                this.$store.dispatch('shifts/fetchShifts')
                    .then(response => {
                        this.shifts = this.$store.getters['shifts/getShifts'];
                        // this.updateRecordsList();
                    })

                // Load Shift Plans
                this.$store.dispatch('shifts/fetchShiftPlans2',{filtered: 1})
                    .then(response => {
                        this.shiftPlans = this.$store.getters['shifts/getShiftPlans2'];
                        this.filterShiftPlans();
                    })
            },

            loadShiftData() {
                this.loadShifts()
                // Load Shift Plans
                this.$store.dispatch('shifts/fetchShiftPlans2')
                    .then(response => {this.filterShiftPlans();})
                // Reset Shift Form
                this.resetShiftUpdateForm();
            },

        },

        computed: {
            // Find Shift ID
            shiftID(){
                if(this.selectedShift){return this.selectedShift.id} else{return null;}
            },

            // Selected Shift Plan Users
            selectedShiftPlanUsers(){
                if(this.selectedShift) {
                    if(this.selectedShift.users){
                        if(this.selectedShift.users.length > 0){
                            return this.selectedShift.users;
                        }
                    }
                } else {return [];}
            },

            pageLimit(){
                return this.sorting.limit;
            },

            shiftPlanAccess(){
                //
            }

        },

        watch: {
            // Watch Pagination Changes
            timesheetsPages: function(newValue, oldValue){
                if(newValue){this.updateTicketsPaginationObject();}
            },
            pageLimit(newValue, oldValue){
                if(newValue !== oldValue){this.updateRecordsList();}
            },
            $route(to, from) {
                if(from.hash !== to.hash){this.selectShift({id: to.hash.substring(1)})}
            },
        },
        mounted() {
            // alert(JSON.stringify(location.hash))
            if(location.hash){this.selectShift({id: location.hash.substring(1)})}
        },

        created() {
            this.loadShiftData();
        },

        beforeDestroy() {
            this.$store.dispatch('shifts/resetSearchFilters');
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/hr/attendance/shift-plans.vue